export const BalanceHours = {
  "Saldo total acumulado": "Saldo total acumulado",
  "Saldo de horas no período acumulado": "Saldo de horas en el período acumulado",
  "Data": "Fecha",
  "Horas necesarias": "Horas necesarias",
  "Horas trabalhadas": "Horas trabajadas",
  "Saldo": "Saldo",
  "Pode conter fatores multiplicações nas horas extras aplicadas. Qualquer dúvida, verifique com seu gestor.": "Puede contener factores de multiplicación en las horas extras aplicadas. Si tiene alguna duda, consulte con su gerente.",
  "Saldo de horas": "Saldo de horas",
  "Últimos 30 dias": "Últimos 30 días",
  "tooltip_update": "La última actualización de datos se realizó el día {date}. Para actualizar nuevamente, haga clic aquí.",
};


// WEBPACK FOOTER //
// ./src/resources/es/BalanceHours.js